var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoostersStarBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 253,
    viewBox: "0 0 252 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7_4802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126 66.8984L128.384 114.517L148.809 71.4354L132.789 116.341L168.145 84.3555L136.16 119.712L181.066 103.692L137.984 124.117L185.603 126.5L137.984 128.884L181.066 149.309L136.16 133.289L168.145 168.645L132.789 136.66L148.809 181.566L128.384 138.484L126 186.103L123.617 138.484L103.192 181.566L119.212 136.66L83.8555 168.645L115.841 133.289L70.9354 149.309L114.017 128.884L66.3984 126.5L114.017 124.117L70.9354 103.692L115.841 119.712L83.8555 84.3555L119.212 116.341L103.192 71.4354L123.617 114.517L126 66.8984Z",
    fill: "#8D94D5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_7_4802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126 11L129.091 103.025L155.894 14.9356L135.061 104.625L183.75 26.4741L140.414 107.715L207.671 44.8292L144.785 112.086L226.026 68.75L147.875 117.439L237.564 96.6064L149.475 123.409L241.5 126.5L149.475 129.591L237.564 156.394L147.875 135.561L226.026 184.25L144.785 140.914L207.671 208.171L140.414 145.285L183.75 226.526L135.061 148.375L155.894 238.064L129.091 149.975L126 242L122.909 149.975L96.1064 238.064L116.939 148.375L68.25 226.526L111.586 145.285L44.3292 208.171L107.215 140.914L25.9741 184.25L104.125 135.561L14.4356 156.394L102.525 129.591L10.5 126.5L102.525 123.409L14.4356 96.6064L104.125 117.439L25.9741 68.75L107.215 112.086L44.3292 44.8292L111.586 107.715L68.25 26.4741L116.939 104.625L96.1064 14.9356L122.909 103.025L126 11Z",
    fill: "#11EADF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7_4802",
    x: 59.5984,
    y: 60.0984,
    width: 132.804,
    height: 132.804,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4,
    result: "effect1_foregroundBlur_7_4802"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7_4802",
    x: 0,
    y: 0.5,
    width: 252,
    height: 252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25,
    result: "effect1_foregroundBlur_7_4802"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostersStarBg);
export default __webpack_public_path__ + "static/media/BoostersStarBg.c457e2b627c4bc7afa96518d65754261.svg";
export { ForwardRef as ReactComponent };